import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, resource } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';

import { firstValueFrom } from 'rxjs';

import { Product } from '../schemas';
import { AgreementService, ClientService, Jira } from '../service';

@Component({
  selector: 'lcm-product-detail-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTableModule, RouterModule, DecimalPipe, MatChipsModule],
  templateUrl: './product-detail-table.html',
  styles: ``,
})
export class ProductDetailTable {
  clientService = inject(ClientService);
  agreementService = inject(AgreementService);
  jira = inject(Jira);

  product = input.required<Product>();

  projectValue = computed(() => {
    const product = this.product();
    // Sum invoiced purchased hours (status 20 = invoiced)
    const purchased =
      product.PurchasedHours?.reduce<number>(
        (total, item) => (item.Status === 20 ? total + item.Hours * item.HourlyRate : total),
        0,
      ) || 0;

    // Sum invoiced milestones (status 20 = invoiced)
    const milestone =
      product.Milestones?.reduce<number>((total, item) => (item.Status === 20 ? total + item.Value : total), 0) || 0;

    return purchased + milestone;
  });

  completedSpResource = resource({
    params: () => ({ product: this.product() }),
    defaultValue: 0,
    loader: async ({ params }) => {
      const info = await firstValueFrom(this.jira.getProjectSpCompleted(params.product.JiraTitle));
      return info.Done;
    },
  });

  completedSp = computed(() => this.completedSpResource.value());

  client = computed(() => this.clientService.clients().find((it) => it.ClientCode === this.product().ClientCode));

  agreements = computed(() =>
    this.agreementService.agreements().filter((item) => item.ClientCode === this.product().ClientCode),
  );
}
